<template>
  <div class="h-100">
    <b-jumbotron header="Welcome to AEGIS - Kenya" lead="" fluid v-if="STUDY == 'kenya'">
      <hr class="my-4">
      <b-button variant="primary" size="lg" :to="{name: 'dashboard'}">Continue to Data Portal</b-button>
    </b-jumbotron>
    <b-jumbotron header="Welcome to AEGIS - Mali" lead="" fluid v-if="STUDY == 'mali'">
      <hr class="my-4">
      <b-button variant="primary" size="lg" :to="{name: 'dashboard'}">Continue to Data Portal</b-button>
    </b-jumbotron>
    <b-jumbotron header="Welcome to AEGIS - Sri Lanka" lead="" fluid v-if="STUDY == 'srilanka'">
      <hr class="my-4">
      <b-button variant="primary" size="lg" :to="{name: 'dashboard'}">Continue to Data Portal</b-button>
    </b-jumbotron>
    <b-jumbotron header="Welcome to AEGIS - Uganda" lead="" fluid v-if="STUDY == 'uganda'">
      <hr class="my-4">
      <b-button variant="primary" size="lg" :to="{name: 'dashboard'}">Continue to Data Portal</b-button>
    </b-jumbotron>
    <!-- add eavetubes -->
    <b-jumbotron header="Welcome to Eave Tubes" lead="" fluid v-if="STUDY == 'eavetubes'">
      <hr class="my-4">
      <b-row>
        <b-col lg="4" class="pb-2"><b-button variant="primary" size="lg" :to="{name: 'dashboard'}">Continue to Data Portal</b-button></b-col>
      </b-row>
    </b-jumbotron>
  </div>
</template>

<script>
  // @ is an alias to /src
  import BaseTemplate from '@/layouts/BaseTemplate.vue'

  export default {
    name: 'home',
    mixins: [BaseTemplate],
  }
</script>